var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuthoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D71920",
    d: "M0 0h56v56H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.167 16.065c-10.72.74-18.403 5.896-18.161 12.188.346 9.026 16.549 14.6 29.728 10.228 11.16-3.704 13.71-12.697 5.225-18.434-4.164-2.816-10.821-4.395-16.792-3.982zm-8.219 4.025c5.439.595 9.511 3.64 10.154 7.59.43 2.64-1.121 5.535-3.27 6.104-.973.258-2.066-.22-2.066-.903 0-.329.167-.425.797-.461.862-.05 1.43-.548 1.437-1.609.006-.94-.409-1.543-1.667-1.811-.751-.068-2.213 0-2.333 0v7h-6V20.055l.327-.025c.21-.043 2.078 0 2.621.06zM41 20v16h-6v-7h-.237c-.41-.074-1.276.004-1.677.093-1.342.295-2.225.831-2.086 1.873.119.894.707 1.398 1.735 1.454.835.045 1.249.458.744.955-1.169 1.15-3.402.182-4.51-1.954-1.837-3.546.114-7.8 4.567-9.956 1.682-.815 3.695-1.317 5.774-1.44.384-.022 1.507-.047 1.69-.025zm-18.597 4.124c-.241.089-.013.344.429.48.55.169.805-.115.324-.362-.272-.14-.569-.186-.753-.118zm11.292-.018c-.628.143-.906.549-.375.549.351 0 .89-.29.831-.446-.04-.105-.243-.15-.456-.103zM22.005 27v1h4.373l-4.375-1zm11.994 0L30 28h4v-1z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuthoot);
export default __webpack_public_path__ + "static/media/Muthoot.e7e300a2416cacad7acb1cbd9e0abb6a.svg";
export { ForwardRef as ReactComponent };